import { backendUrl } from '../gameplanUtils';

const json = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.detail || `Request failed (${res.status})`);
  return data;
};

const auth = (token) => ({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });

export const getCreditTeam = (token) => fetch(`${backendUrl}/api/gameplan/credit-team`, { headers: auth(token) }).then(json);
export const setCreditPause = (token, paused) =>
  fetch(`${backendUrl}/api/gameplan/credit-team/pause`, { method: 'POST', headers: auth(token), body: JSON.stringify({ paused }) }).then(json);
export const getFile = (token, id) => fetch(`${backendUrl}/api/gameplan/sla/deals/${id}`, { headers: auth(token) }).then(json);
export const postEvent = (token, id, event, payload = {}) =>
  fetch(`${backendUrl}/api/gameplan/workflow/${id}/event`, { method: 'POST', headers: auth(token), body: JSON.stringify({ event, payload }) }).then(json);
export const getSlaSettings = (token) => fetch(`${backendUrl}/api/gameplan/sla/settings`, { headers: auth(token) }).then(json);
export const putSlaSettings = (token, body) => fetch(`${backendUrl}/api/gameplan/sla/settings`, { method: 'PUT', headers: auth(token), body: JSON.stringify(body) }).then(json);

/* One-click workflow action for a derived task. Returns {handled, message}; caller opens the file panel when unhandled. Throws on error. */
export const quickTaskAction = async (token, t) => {
  if (t.key.startsWith('mir_return:') && !(t.detail || '').startsWith('Internal')) {
    await postEvent(token, t.deal_id, 'mir_returned', { mir_id: t.mir_id });
    return { handled: true, message: `MIR returned to ${t.lender || 'lender'}` };
  }
  if (t.key === 'cond_return') { await postEvent(token, t.deal_id, 'conditions_returned', {}); return { handled: true, message: 'Conditions returned' }; }
  if (t.key.startsWith('manual:')) { await postEvent(token, t.deal_id, 'complete_manual_task', { task_id: t.key.split(':')[1] }); return { handled: true, message: 'Task done' }; }
  const oneClick = { package: 'mark_ready_to_lodge', handover: 'handover_complete' };
  if (oneClick[t.key]) { await postEvent(token, t.deal_id, oneClick[t.key], {}); return { handled: true, message: 'Done' }; }
  return { handled: false };
};

export const PRIORITY_STYLE = {
  URGENT: 'bg-rose-600 text-white',
  HIGH: 'bg-amber-400 text-slate-900',
  NORMAL: 'bg-slate-200 text-slate-700',
};

export const HEALTH_STYLE = {
  'ON TRACK': 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  'ACTION NEEDED': 'bg-sky-50 text-sky-700 ring-sky-200',
  WAITING: 'bg-slate-100 text-slate-600 ring-slate-200',
  'AT RISK': 'bg-amber-50 text-amber-700 ring-amber-200',
  OVERDUE: 'bg-rose-50 text-rose-700 ring-rose-200',
  COMPLETE: 'bg-slate-100 text-slate-500 ring-slate-200',
};

export const money = (v) => {
  const n = Number(v || 0);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (n >= 1_000) return `$${Math.round(n / 1_000)}k`;
  return `$${Math.round(n)}`;
};

export const fmtTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('en-AU', { timeZone: 'Australia/Hobart', weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
};
